import { createContext } from "react";

export const ModalScopeContext = createContext(null);
